import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  modalHeader: {
    marginBottom: 120
  },
  titleSecondary: {
    maxWidth: 500
  },
  addressContainer: {
    marginTop: 25,
    marginBottom: 10
  },
  addressField: {
    width: 500
  },
  saveBtn: {
    position: 'relative',
    float: 'right',
    left: 325,
    width: 175
  }
}));

export default useStyles;
